import { createContext, useContext } from "react";

export interface SolveCatalogItem {
  readonly id: string;
  readonly title: string;
}

/**
 * The SOLVE picker + owner vocabulary the SOLVE Actions editor needs, supplied
 * by the host. Same shape and the same reasons as `VsmCatalog`: the design
 * system stays data-blind, and the host owns paging, search and the query
 * cache.
 *
 * `owners` is a VOCABULARY, not an account directory. The values are the free
 * text people typed into the two source widgets, offered so an author can pick
 * rather than retype. Nothing here resolves a name to a user.
 */
export interface SolveCatalog {
  readonly solves: readonly SolveCatalogItem[];
  /** Owner text present in the widget's currently SAVED source + SOLVE scope. */
  readonly owners: readonly string[];
  readonly isLoading?: boolean;
  readonly isLoadingMore?: boolean;
  readonly error?: string | null;
  readonly hasMore?: boolean;
  readonly searchQuery?: string;
  /** Called with the saved selection so the host can resolve those rows too. */
  readonly activate?: (selectedIds: readonly string[]) => void;
  readonly onSearchChange?: (query: string) => void;
  readonly onLoadMore?: () => void;
  readonly onRetry?: () => void;
}

const Ctx = createContext<SolveCatalog | null>(null);

export const SolveCatalogProvider = Ctx.Provider;

export function useSolveCatalog(): SolveCatalog | null {
  return useContext(Ctx);
}
